import type { Typography, Vibe } from './zod.js';

const SYSTEM_SANS =
  'ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

const HOUSE: Typography = {
  headingStack: `"Playfair Display", Georgia, "Times New Roman", serif`,
  bodyStack: `Inter, ${SYSTEM_SANS}`,
  borderRadius: '18px',
  borderWidth: '1px',
  letterSpacing: '-0.02em',
};

const HOUSE_FONTS =
  'https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,500;0,600;0,700;1,500&family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap';

export const TYPOGRAPHY_BY_VIBE: Readonly<Record<Vibe, Typography>> = {
  'The Bold': HOUSE,
  'The Professional': HOUSE,
  'The Modern': HOUSE,
  'The Artisan': HOUSE,
  'The Wellness': HOUSE,
  'The Editorial': HOUSE,
  'The Luxe': HOUSE,
  'The Tech': HOUSE,
  'The Heritage': HOUSE,
};

export function typographyForVibe(_vibe: Vibe): Typography {
  return { ...HOUSE };
}

export const GOOGLE_FONTS_HREF_BY_VIBE: Readonly<Record<Vibe, string>> = {
  'The Bold': HOUSE_FONTS,
  'The Professional': HOUSE_FONTS,
  'The Modern': HOUSE_FONTS,
  'The Artisan': HOUSE_FONTS,
  'The Wellness': HOUSE_FONTS,
  'The Editorial': HOUSE_FONTS,
  'The Luxe': HOUSE_FONTS,
  'The Tech': HOUSE_FONTS,
  'The Heritage': HOUSE_FONTS,
};
